import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { Mask } from '../mask.interface';
import { Validation } from '../validation.interface';
import { FormControl } from '@angular/forms';
export class CreditCardExpirationDateModel implements Mask, Validation {

  static CREDIT_CARD_EXPIRATION_DATE = 'creditCardExpirationDate';
  static CREDIT_CARD_EXPIRATION_DATE_ERROR_DESCRIPTION = 'Data de expiração do cartão de crédito inválida';
  private creditCardExpirationDateMask = [/[0-9]/, /\d/, '/', /\d/, /\d/];

  static creditCardExpirationDateValidation(expirationDate: FormControl) {
    if (expirationDate.value) {
      const _expirationDate = expirationDate.value.split('/');
      if (parseFloat(_expirationDate[0]) > 12) {
        return { [CreditCardExpirationDateModel.CREDIT_CARD_EXPIRATION_DATE]: true, description: 'Invalid Month' };
      }
      if (parseFloat(_expirationDate[1]) < parseFloat(new Date().getFullYear().toString().split('20')[1])) {
        return { [CreditCardExpirationDateModel.CREDIT_CARD_EXPIRATION_DATE]: true, description: 'Invalid Year' };
      }
      if ((parseFloat(_expirationDate[1]) === parseFloat(new Date().getFullYear().toString().split('20')[1])) &&
        (_expirationDate[0]) < new Date().getMonth()) {
        return { [CreditCardExpirationDateModel.CREDIT_CARD_EXPIRATION_DATE]: true, description: 'Invalid Year' };
      }
      return null;
    } else {
      return { [CreditCardExpirationDateModel.CREDIT_CARD_EXPIRATION_DATE]: true, description: 'Invalid field' };
    }
  }

  getMaskRule(): (string | RegExp)[] | Function | boolean {
    return this.creditCardExpirationDateMask;
  }

  getValidatorsName(): string {
    return CreditCardExpirationDateModel.CREDIT_CARD_EXPIRATION_DATE;
  }
  getValidatorsErrorDescription(): string {
    return CreditCardExpirationDateModel.CREDIT_CARD_EXPIRATION_DATE_ERROR_DESCRIPTION;
  }
  getValidatorsRule(): ValidatorFn {
    return CreditCardExpirationDateModel.creditCardExpirationDateValidation;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/creditCardExpirationDate.model.ts